import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getSubNavAppointments: () => NavRoute = () => ({
	name: getName()
    , security: sec => sec.coreFeatures
    , href: 'appointments'
    , children: getAreas()
    , isSubNav: true
});

function getName(): string {
	let url = globalThis.location.href;
	if (url.includes('realtors/appointments/edit/')) { return "Edit Appointment"; }	
	return "Appointments";
}

function getAreas(): NavRoute[] {
	let id: string = "";
	let url = globalThis.location.href;

	if (url.includes('realtors/appointments/edit/')) { id = url.substring(url.lastIndexOf('/') + 1); }

	if (id === "") { return null!; }

	return [
		{
			name: 'Back'
			, exact: true
			, path: `realtors/appointments/list`
		},
		{
			name: 'Details'
			, exact: true
			, path: `realtors/appointments/edit/${id}`
            , activeNavLink: 'realtors/appointments'
            , secondaryNav: [ 'Realtors', 'Appointments', 'Details' ]
            
		}
	]
}